import { AbstractComponent } from './abstract.component';
import { copyMetaData } from '../../functions/meta.functions';
import { SearchStateService } from '../../services/search-state.service';
import { SearchMode } from '../../enum/searchMode';

export abstract class AbstractSearchComponent extends AbstractComponent {
  stateService: SearchStateService;

  constructor(stateService: SearchStateService) {
    super();
    this.stateService = stateService;
  }

  copyLastRequest(template, searchmode: SearchMode = SearchMode.searchStandard) {
    {
      if (!this.stateService.lastSearchMode || (this.stateService.lastSearchMode && this.stateService.lastSearchMode === searchmode)) {
        if (this.stateService.lastRequest) {
          return copyMetaData(template, this.stateService.lastRequest);
        }
      }
      return template;
    }
  }
}
